var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxCart({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1863 6.1925C18.1097 6.08173 18.0073 5.99119 17.888 5.92864C17.7687 5.86608 17.636 5.83338 17.5013 5.83334H6.11214L5.15047 3.525C5.02438 3.22102 4.81086 2.96133 4.53699 2.77885C4.26312 2.59636 3.94123 2.49932 3.61214 2.5H1.66797V4.16667H3.61214L7.56547 13.6542C7.62879 13.806 7.73562 13.9356 7.87249 14.0268C8.00936 14.118 8.17016 14.1667 8.33464 14.1667H15.0013C15.3488 14.1667 15.6596 13.9508 15.7821 13.6267L18.2821 6.96C18.3294 6.83385 18.3453 6.69813 18.3287 6.56446C18.312 6.43079 18.2631 6.30316 18.1863 6.1925ZM14.4238 12.5H8.89047L6.80714 7.5H16.2988L14.4238 12.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7513 17.5C9.44166 17.5 10.0013 16.9404 10.0013 16.25C10.0013 15.5596 9.44166 15 8.7513 15C8.06095 15 7.5013 15.5596 7.5013 16.25C7.5013 16.9404 8.06095 17.5 8.7513 17.5Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5846 17.5C15.275 17.5 15.8346 16.9404 15.8346 16.25C15.8346 15.5596 15.275 15 14.5846 15C13.8943 15 13.3346 15.5596 13.3346 16.25C13.3346 16.9404 13.8943 17.5 14.5846 17.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxCart);
export default __webpack_public_path__ + "static/media/bx-cart.2ba0a18f276280afa373b43733415941.svg";
export { ForwardRef as ReactComponent };